
import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalDefaultPopup from '@/components/ModalDefaultPopup.vue';

@Component({
  components: {
    ModalDefaultPopup
  }
})
export default class Modal extends Vue {
  @Prop({ type: Boolean, required: true })
  isOpen!: boolean;

  @Prop({ type: String, default: '' })
  type!: string;

  @Prop({ type: String, default: '' })
  title!: string;

  @Prop({ type: String, default: '' })
  text!: string;

  @Prop({ type: String, default: '' })
  html!: string;

  @Prop({ type: String, default: '' })
  buttonOK!: string;

  @Prop({ type: String, default: '' })
  buttonNG!: string;

  private get isBackground(): boolean {
    if (this.type === 'shootTypeConfirmation') return false;
    if (this.type === 'faceFrontError') return false;
    if (this.type === 'faceActionError') return false;
    return true;
  }
}
